<div class="gb_langChange">
  <button type="button" tabindex="0" id="gb_langSelection" aria-label="Seleziona la lingua" aria-controls="gb_languages"
          aria-haspopup="true" title="Seleziona la lingua" class="gb_buttonLang gb-button-reset" (click)="openLanguageMenu()">
    <ng-container *ngIf="storeService.languagesCollection">
      <ng-container *ngFor="let lang of storeService.languagesCollection">
      <span *ngIf="lang.default">
        {{lang.code}}
      </span>
      </ng-container>
    </ng-container>
  </button>
  <div id="gb_languages" aria-labelledby="gb_langSelection" [attr.aria-hidden]="!isLanguageMenuOpened"
       [ngClass]="{ 'opnsub': isLanguageMenuOpened }">
    <ng-container *ngIf="storeService.languagesCollection">
      <ng-container *ngFor="let lang of storeService.languagesCollection">
        <div *ngIf="!lang.default" class="mb-2">
          <a href="javascript:void(0);" (click)="setLanguage(lang.code)" title="{{lang.name}}"
             [attr.aria-label]="lang.name" tabindex="0" class="d-flex align-items-center gap-2 mt-2">
            <img src="./assets/gb/lang/{{lang.code | lowercase}}.svg" [alt]="lang.name">
            {{lang.code}}
          </a>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
